import axios from "axios";
import React, {useEffect, useState,useRef,Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import { render } from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    FormatNumberByhkh,
    Cart_get_list_product,
} from '../../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';

import Master_Front from "../../../pages/Master_Front";

import "../../../components/assets/css/profile.css"
import "../../../components/assets/css/Order_view.css"
import PrintIcon from '@mui/icons-material/Print';

import ReactFullPageLoadinghk from "../../../components/layaout/LoadingFullpagehk";
import Menu_panel from "../../../components/layaout/Menu-panel";

import Grid from '@mui/material/Grid';
import {Button} from "@mui/material";
import LazyLoad from "react-lazy-load";
import banner from "../../../assets/img/Rectangle 305.png";

import Order_View_Factor_components from "../../../components/Order_view_factor/Order_View_Factor_components";

const serialize = require('form-serialize');


const My_order_view = () => {

    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    const [list_order_get,setData_list_order] = useState([]);
    /*  end profile */

    const [Data_full_get,setData_full] = useState([]);

    const {id_post_getuser} = useParams();


    useEffect(() => {
        scrollTo_uphk();
        if(check_login_appbk()==false){
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );
            return false;
        }
        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page= () => {

        if(check_login_appbk()==false){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" ); }

        const data_form = {post_id:id_post_getuser};
        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };


        Setloadinghkfullshow("true");

        axios.post(`${clientconfigwebapp.siteurl}api/v1/my-orders-view`,data_form,config)
            .then((res) => {
///console.log(res.data);
                Setloadinghkfullshow("false");

                if(String(res.data.data).length > 0) {  setData_full(res.data.data); }

///console.log(Data_full_get,"Data_full_get");
                if(String(res.data).length > 0) {

                    if(String(res.data.data)=="login-show"){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );  }


                    if(String(res.data.msgwebapp).length > 0){  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,}); }


                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }

                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }


                 if(String(res.data.data.data_list).length > 0) {  setData_list_order(res.data.data.data_list); }



                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }



            }).catch((err) =>{
            Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 435346', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });





    }




    const Print_bk = () =>{
        //console.log('print');
        let printContents = document.getElementById('printablediv').innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }


    return (
        <>
            <Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}  />
                <ToastContainer />


                <img src={banner} alt="banner" className='baner-panel'/>

                <section className='w-100 flexRowBetStart account-section-container'>




                    <Grid container direction="row" spacing={2} style={{paddingTop:"14px"}}>


                        <Grid  item className="item_inputbk" lg={3} md={3} sm={12} xs={12} style={{marginTop:"4px"}}>


                            <div className='account-aside'>
                                <Menu_panel wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} />
                            </div>

                        </Grid>


                        <Grid  item className="item_inputbk" lg={9} md={9} sm={12} xs={12} style={{marginTop:"4px"}}>



                            <section  className='account-content'>


                                <div className={"title_page_panel"} style={{width: '100%',"marginBottom":"0px", paddingBottom: '0px', display: 'flex', flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <div ><span style={{"color":"var(--c7)","fontFamily":"iran","fontSize":"19px","fontStyle":"normal","fontWeight":"700","lineHeight":"normal","paddingTop":"35px","display":"block","paddingBottom":"28px"}}>مشاهده فاکتور</span></div>

                                    <div>
                                        <PrintIcon onClick={ Print_bk }></PrintIcon>
                                    </div>
                                </div>



<div id={"printablediv"}>
    <Order_View_Factor_components data_info_get={Data_full_get}  />



    <div style={{ padding: "13px 10px 13px 10px" }}>
        <div >
<span style={{ fontWeight: "bold", fontSize: 15, color: "color: var(--c7);" }}>
ایتم سفارش
</span>
        </div>
    </div>


    { list_order_get.length > 0 ?  (

        <Fragment>   <div className="box_full_table_typea_bk_v1">

            <div className="table_typea_bk" style={{backgroundColor: "transparent"}}>
                <div className="table_typea_bk_theader" style={{backgroundColor:"#999282"}}>
                    <div className="table_typea_bk_header">ردیف</div>
                    <div className="table_typea_bk_header">عنوان محصول</div>
                    <div className="table_typea_bk_header">قیمت</div>
                    <div className="table_typea_bk_header">تعداد</div>
                </div>



                {






                    list_order_get.map((item_post,index) => {



                        {
                            var ite_countrow=   parseInt(index)+1;

                        }
                        return(



                            <div className="table_typea_bk_row">


                                <div className="table_typea_bk_small">
                                    <div className="table_typea_bk_cell">ردیف</div>
                                    <div className="table_typea_bk_cell"><span>{ite_countrow}</span></div>
                                </div>

                                <div className="table_typea_bk_small">
                                    <div className="table_typea_bk_cell">عنوان محصول</div>
                                    <div className="table_typea_bk_cell">
                                        <span>{item_post.order_title}</span>
                                    </div>
                                </div>



                                <div className="table_typea_bk_small">
                                    <div className="table_typea_bk_cell">قیمت</div>
                                    <div className="table_typea_bk_cell">
                                        <span>{item_post.price_product}</span>
                                    </div>
                                </div>


                                <div className="table_typea_bk_small">
                                    <div className="table_typea_bk_cell">تعداد</div>
                                    <div className="table_typea_bk_cell">
                                        <span>1 عدد</span>
                                    </div>
                                </div>



                            </div>


                        )

                    })

                }










            </div>
        </div>

        </Fragment>

    ) : (
        <Fragment>

            <span style={{"display":"block","textAlign":"center","paddingBottom":"32px","paddingTop":"32px"}}>آیتمی یافت نشد </span>

        </Fragment>)

    }
</div>






                            </section>


                        </Grid>






                    </Grid>






                </section>









            </Master_Front>

        </>
    );
}


export default My_order_view;
